import { BaseService, } from '../types/index.js';
export class Security extends BaseService {
    getWalletBalanceCheck(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/user/security/balanceCheck',
            params,
        });
    }
    getPaymentSecurityList(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/user/security/transferLimit',
            params,
        });
    }
}
